import styled from 'styled-components';

export const ColorPickerWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 14px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.default[200]};
`;

export const ColorPickerContainer = styled.div`
  width: 100%;
  height: 100%;

  .react-colorful {
    gap: 10px;
    width: 100%;

    &__saturation {
      margin: 0 0 0 0;
      border-radius: 4px;
    }

    &__hue {
      width: 100%;
      height: 16px;
      border-radius: 12px;
    }

    &__pointer {
      cursor: grab;
    }

    &__hue {
      border-radius: 4px;
    }
  }
`;
